import style from './Loading.module.css'

export default function Loading (props) {
  return <span {...Object.assign({}, props, { className: props.className + ' ' + style.loading })} />
}
